import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import Button from '../common/Button';
import '../../styles/components/landing/HeroSection.css';

const HeroSection = ({
  eyebrow,
  title,
  subtitle,
  primaryCta,
  secondaryCta,
  image,
  badges = [],
  trust,
}) => {
  return (
    <section className="ls-hero">
      <div className="container">
        <div className="ls-hero__grid">
          <motion.div
            className="ls-hero__text"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            {eyebrow && (
              <div className="ls-hero__eyebrow">
                <span className="ls-hero__dot" />
                {eyebrow}
              </div>
            )}

            <h1 className="ls-hero__title">{title}</h1>
            {subtitle && <p className="ls-hero__subtitle">{subtitle}</p>}

            {badges.length > 0 && (
              <div className="ls-hero__badges">
                {badges.map((b, i) => (
                  <div key={i} className="ls-hero__badge">
                    {b.icon}
                    <span>{b.label}</span>
                  </div>
                ))}
              </div>
            )}

            <div className="ls-hero__actions">
              {primaryCta && (
                <Button
                  variant="primary"
                  size="large"
                  onClick={primaryCta.onClick}
                  className="btn-with-icon"
                >
                  {primaryCta.label}
                  <ChevronRight size={18} />
                </Button>
              )}
              {secondaryCta && (
                <Button variant="outline" size="large" onClick={secondaryCta.onClick}>
                  {secondaryCta.label}
                </Button>
              )}
            </div>

            {trust && (
              <div className="ls-hero__trust">
                {trust.avatars && (
                  <div className="ls-hero__avatars">
                    {trust.avatars.slice(0, 4).map((src, i) => (
                      <img
                        key={i}
                        src={src}
                        alt=""
                        onError={(e) => (e.target.src = `https://ui-avatars.com/api/?background=random&name=U${i + 1}`)}
                      />
                    ))}
                  </div>
                )}
                <p>{trust.label}</p>
              </div>
            )}
          </motion.div>

          <motion.div
            className="ls-hero__visual"
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: 'easeOut', delay: 0.1 }}
          >
            <div className="ls-hero__phone">
              <img
                src={image}
                alt=""
                onError={(e) =>
                  (e.target.src = 'https://placehold.co/400x800/10083B/FAFAFA?text=LifeUp')
                }
              />
            </div>
            <div className="ls-hero__glow ls-hero__glow--a" />
            <div className="ls-hero__glow ls-hero__glow--b" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
